import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const FaceBackgroundRemoverInputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-image', title: 'Face Background Remover', subtitle: 'Remove background from a face image via Surepass' }}
        fileFields={[
            { name: 'file', label: 'Image', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{ path: '/surepass/face/background-remover' }}
        consentReportType="face-background-remover"
        submitLabel="Remove Background"
        successSummary="Background removed"
        errorSummary="Background removal failed"
        confirmHeader="Confirm background removal"
        confirmAcceptLabel="Yes, process"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Background Removed', icon: 'pi-image' }}
    />
);

export default FaceBackgroundRemoverInputComponent;
